import { useState, type FormEvent } from 'react';
import { api } from '../api/client';

export default function ChangePasswordPage() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setInfo('');
    if (next.length < 12) {
      setError('new password must be at least 12 chars');
      return;
    }
    if (next !== confirm) {
      setError('passwords do not match');
      return;
    }
    setBusy(true);
    try {
      await api('/admin/password', {
        method: 'POST',
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      setCurrent('');
      setNext('');
      setConfirm('');
      setInfo('password changed');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <h1>change password</h1>
      {error && <div className="error-banner">{error}</div>}
      {info && <div className="success-banner">{info}</div>}
      <form onSubmit={submit}>
        <label className="label">Current password</label>
        <input
          type="password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          autoComplete="current-password"
          required
        />
        <div style={{ height: 12 }} />
        <label className="label">New password (&ge; 12 chars)</label>
        <input
          type="password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          autoComplete="new-password"
          minLength={12}
          required
        />
        <div style={{ height: 12 }} />
        <label className="label">Confirm new password</label>
        <input
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
          minLength={12}
          required
        />
        <div className="actions">
          <button type="submit" disabled={busy}>
            {busy ? 'updating…' : 'update password'}
          </button>
        </div>
      </form>
    </div>
  );
}
